import React, { useEffect } from 'react';
import { useField } from 'formik';
import SpecialInstructions from './SpecialInstructions';
import classNames from '../../../utility/classNames';
import DescriptionTooltipModal from './DescriptionTooltipModal';
import Tooltip from '../../Tooltip';

export default function YesNo({
  name,
  label,
  required,
  description,
  tooltipHeading,
  tooltipFormula,
  layout = 'default',
  specialInstructions,
  defaultValue,
  preValue,
  yesLabel,
  noLabel,
  hideLabel,
  toggleColour,
  afterPosition,
}) {
  // eslint-disable-next-line no-unused-vars
  const [field, meta, helpers] = useField(name);
  const { setValue, setTouched } = helpers;

  const noToggleColour =
    toggleColour === 'green'
      ? `peer-checked:bg-primary-500`
      : 'peer-checked:bg-primary-500';
  const yesToggleColour =
    toggleColour === 'green'
      ? `peer-checked:bg-primary-500`
      : 'peer-checked:bg-primary-500';

  useEffect(() => {
    if (field?.value === '') setValue(undefined);
  }, [field.value]);

  useEffect(() => {
    if (preValue) setValue(preValue);
    if (
      !preValue &&
      preValue !== false &&
      (field?.value === undefined || field?.value === '') &&
      defaultValue !== undefined
    ) {
      setValue(defaultValue);
    }
  }, [preValue]);

  if (!field && !field.value) {
    return <div>loading...</div>;
  }

  const handleChange = (e) => {
    if (e.target.value === 'true') {
      setValue(true);
    }
    if (e.target.value === 'false') {
      setValue(false);
    }

    setTouched(true);
  };

  return (
    <div
      className={classNames(
        (layout === 'compact' || layout === 'tableNoLabel') && 'my-0 space-y-0',
        layout === 'tableNoLabel' && 'w-full',
        hideLabel && 'mb-4 -mt-1'
      )}
    >
      {/* <fieldset value={field.value} {...props}> */}
      <div
        className={classNames(
          'sm:grid sm:grid-cols-3-inputs sm:gap-2',

          layout === 'stacked' && 'sm:gap-2',
          (layout === 'compact' || layout === 'tableNoLabel') &&
            'sm:gap-4 pt-0 border-none',
          layout === 'tableNoLabel' ? 'sm:grid-cols-3 w-full' : 'sm:grid-cols-3'
        )}
      >
        {layout !== 'tableNoLabel' && !hideLabel && (
          <>
            <legend
              className={classNames(
                'h-full flex items-center',

                layout !== 'stacked' && 'col-span-3 sm:col-span-1',
                layout === 'stacked' && 'col-span-3'
              )}
            >
              <span className="text-md font-normal text-neutral-900 whitespace-nowrap">
                {label}
                {required && <span>*</span>}{' '}
                {description && layout === 'compact' && (
                  <DescriptionTooltipModal description={description} />
                )}
                {description && layout !== 'compact' && (
                  <Tooltip
                    classes="whitespace-normal"
                    text={description}
                    heading={tooltipHeading}
                    formula={tooltipFormula}
                    type="info"
                  />
                )}
              </span>
            </legend>

            {specialInstructions && (
              <SpecialInstructions
                instructions={specialInstructions}
                name={name}
                label=" "
              />
            )}
          </>
        )}

        <div
          className={classNames(
            afterPosition === 'absolute' &&
              layout === 'tableNoLabel' &&
              'absolute top-4 left-4 z-20',

            'space-y-4 sm:space-y-0 flex justify-start items-center gap-1',
            layout === 'tableNoLabel'
              ? 'col-span-3'
              : 'col-span-3 sm:col-span-2'
          )}
        >
          <div className="relative sm:flex sm:items-center h-8">
            <fieldset className="inline-flex items-center justify-center p-[3px] h-8 bg-white border border-neutral-100 rounded-md text-neutral-500 cursor-pointer">
              <label
                htmlFor={`_yes_${name}`}
                className="h-full flex items-center justify-center p-0 m-0"
              >
                <input
                  className="hidden peer"
                  type="radio"
                  id={`_yes_${name}`}
                  value={true}
                  name={name}
                  onChange={handleChange}
                  checked={field.value === true}
                />
                <span
                  className={classNames(
                    'h-full text-md py-[2px] px-2 w-full font-normal peer-checked:text-white peer-checked:font-medium bg-white rounded',
                    yesToggleColour
                  )}
                >
                  {yesLabel || 'Yes'}
                </span>
              </label>
              <label
                htmlFor={`_no_${name}`}
                className="h-full flex items-center justify-center  p-0 m-0"
              >
                <input
                  className="hidden peer"
                  type="radio"
                  id={`_no_${name}`}
                  value={false}
                  name={name}
                  onChange={handleChange}
                  checked={!field.value}
                />
                <span
                  className={classNames(
                    'h-full text-md p-[2px] px-2 w-full font-normal peer-checked:text-white peer-checked:font-medium bg-white rounded',
                    noToggleColour
                  )}
                >
                  {noLabel || 'No'}
                </span>
              </label>
            </fieldset>
          </div>
          {hideLabel && description && (
            <Tooltip
              classes="whitespace-normal"
              text={description}
              heading={tooltipHeading}
              formula={tooltipFormula}
              type="info"
            />
          )}
        </div>
      </div>
    </div>
  );
}
